// extracted by mini-css-extract-plugin
export default {"mainContainer":"DemoFinal_mainContainer__k9kaM","title":"DemoFinal_title__SjSct","titleSpan":"DemoFinal_titleSpan__ZAW8Y","button":"DemoFinal_button__6hH91"};